/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_Li1_PreInputs */

const tr_iade_iptal_s11_li1_pre = /** @type {(inputs: Iade_Iptal_S11_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan seçimi dışında panel erişimi kapanır; açık kalan kişisel veri dökümü`)
};

const en_iade_iptal_s11_li1_pre = /** @type {(inputs: Iade_Iptal_S11_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel access closes except for choosing a plan; the personal data statement remains available at`)
};

const de_iade_iptal_s11_li1_pre = /** @type {(inputs: Iade_Iptal_S11_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Panelzugang ist bis auf die Tarifwahl gesperrt; der Auszug der personenbezogenen Daten bleibt unter`)
};

const ru_iade_iptal_s11_li1_pre = /** @type {(inputs: Iade_Iptal_S11_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель блокируется, кроме выбора тарифа; выписка персональных данных остаётся доступной по адресу`)
};

/**
* | output |
* | --- |
* | "Panel access closes except for choosing a plan; the personal data statement remains available at" |
*
* @param {Iade_Iptal_S11_Li1_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_li1_pre = /** @type {((inputs?: Iade_Iptal_S11_Li1_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_Li1_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_li1_pre(inputs)
	if (locale === "de") return de_iade_iptal_s11_li1_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_li1_pre(inputs)
	return tr_iade_iptal_s11_li1_pre(inputs)
});